/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  PriceProvidersRepositoryManager,
  PriceProvidersRepositoryManagerInterface,
} from "../PriceProvidersRepositoryManager";

const _abi = [
  {
    inputs: [],
    name: "InvalidPriceProviderRepository",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
];

export class PriceProvidersRepositoryManager__factory {
  static readonly abi = _abi;
  static createInterface(): PriceProvidersRepositoryManagerInterface {
    return new utils.Interface(
      _abi
    ) as PriceProvidersRepositoryManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceProvidersRepositoryManager {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PriceProvidersRepositoryManager;
  }
}
